import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots'
import React, { startTransition, useEffect } from 'react'


const startChat = () =>
  // eslint-disable-next-line no-undef,func-names
  Verloop(function() {
    this.openWidget()
  })

let isVerloopInitialized = false;

export default function Chat() {

  useEffect(() => {



    let timer;

    if (isVerloopInitialized) {
      return;
    }

    startTransition(() => {
      isVerloopInitialized = true;
      // First ensure the Verloop function exists immediately
      window.Verloop = function(c) { window.Verloop._ = window.Verloop._ || []; window.Verloop._.push(c) };
      window.Verloop._ = window.Verloop._ || [];
      window.Verloop.url = 'https://portea.verloop.io/livechat';

      // Then load the script after a short delay to improve LCP
      timer = setTimeout(() => {
        const script = document.createElement('script');
        script.src = 'https://portea.verloop.io/livechat/script.min.js';
        script.async = true;
        document.body.appendChild(script);

      }, 3000);

    });


    return () => {
      if (timer) clearTimeout(timer);
    }
  }, []);



  return <div className="main-chat">
    <FontAwesomeIcon
      icon={faCommentDots}
      className="icon-main-chat"
      onClick={startChat}
    />
  </div>

}
